import {useCallback} from 'react';

import {BREAKPOINTS} from '../../../../const';
import {useIsModuleVisibleOrEnabled} from '../../../../hooks/components/report-modules/useIsModuleVisibleOrEnabled/useIsModuleVisibleOrEnabled';
import useBreakpoint from '../../../../hooks/dom/useBreakpoint';
import useBudget from '../../../../hooks/providers/useBudget';
import useMainSidebar from '../../../../hooks/providers/useMainSidebar';
import useReport from '../../../../hooks/providers/useReport';
import useWorkspaces from '../../../../hooks/providers/useWorkspaces';
import useReportModuleCoreHandler from '../useReportModuleCoreHandler/useReportModuleCoreHandler';

const useReportModuleClickHandler = () => {
  const {reports, selectedReport, selectedProject: project, setNoProjectsSelectedBackdropOpen, reportSelectedFoldersSirens} = useReport();
  const {alreadyTakenBudgetNames: budgets} = useBudget();
  const {setIsReportAndModulesMobileDrawerOpen, closeAllSidebarRelatedPoppers, setModuleSubmenuOpen} = useMainSidebar();
  const {workspaces, isUserOwnerOfWorkspace} = useWorkspaces();
  const breakpoint = useBreakpoint();
  const coreHandler = useReportModuleCoreHandler();

  const {isModuleVisible} = useIsModuleVisibleOrEnabled();

  return useCallback(
    // eslint-disable-next-line complexity
    async (module, event) => {
      const isModuleVisibleForCurrentReport = isModuleVisible(module);
      const isSmallScreen = breakpoint === BREAKPOINTS.xs || breakpoint === BREAKPOINTS.sm;

      if (!isModuleVisibleForCurrentReport) return;

      const hasExactlyOneSirenSelected = reportSelectedFoldersSirens.length === 1;
      if (module.requiresSirenSelected && !hasExactlyOneSirenSelected) {
        setNoProjectsSelectedBackdropOpen(true);
        return;
      }

      // Close everything related to report modules drawer
      if (!module.hasSubMenu) {
        closeAllSidebarRelatedPoppers();
        setIsReportAndModulesMobileDrawerOpen(false);
      }

      if (module.hasSubMenu && !isSmallScreen) {
        setModuleSubmenuOpen(null);
        return;
      }

      return coreHandler(module, event);
    },
    [project, breakpoint, reports, workspaces, isUserOwnerOfWorkspace, selectedReport, project, budgets, reportSelectedFoldersSirens]
  );
};

export default useReportModuleClickHandler;
